export type AmethystDeviceType = 'DESKTOP' | 'MOBILE' | 'TABLET';
export type AmethystPlatform = 'WEB' | 'APP';

export interface AmethystDeviceContext {
  readonly deviceType: AmethystDeviceType;
  readonly userAgent?: string;
  readonly platform: AmethystPlatform;
}

export function getAmethystDeviceFields(context: AmethystDeviceContext) {
  const touchPoints = typeof window === 'object' ? window?.navigator?.maxTouchPoints : undefined;
  const maxTouchPoints =
    typeof touchPoints === 'number' && Number.isInteger(touchPoints) && touchPoints >= 0 && touchPoints <= 0xffffffff ? touchPoints : undefined;
  return {
    // iPads in desktop mode use a Macintosh UA and may report only one touch point.
    deviceType:
      context.deviceType === 'DESKTOP' && context.userAgent?.includes('Macintosh') && (maxTouchPoints ?? 0) > 0 ? 'TABLET' : context.deviceType,
    platform: context.platform,
    userAgent: context.userAgent,
    maxTouchPoints
  };
}
